import { Box, Chip, Typography } from '@mui/material';
import { inputStatusColorMap } from '@services/offerApplicant/offerApplicantBadgeStatus';
import { useLanguage } from '../../../../contexts/LanguageContext';
import translations from './translations.json';

type SupportedLanguage = keyof typeof translations;

interface ApplicationStatusProps {
    status?: string;
}

const fallbackStatusStyle = {
    backgroundColor: '#20242b',
    color: '#cbd5e1',
    border: '1px solid #3b424d',
};

const ApplicationStatus = ({ status }: ApplicationStatusProps) => {
    const { language } = useLanguage();
    const content = translations[language as SupportedLanguage] || translations.en;
    const statusLabel = status
        ? content.statuses[status as keyof typeof content.statuses] || status
        : content.unknown;

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: 2,
                mb: 2,
                px: { xs: 0.5, sm: 1 },
            }}
        >
            <Typography variant="subtitle1" sx={{ color: '#f8fafc', fontWeight: 600 }}>
                {content.title}
            </Typography>
            <Chip
                size="small"
                label={statusLabel}
                sx={{
                    fontWeight: 600,
                    ...fallbackStatusStyle,
                    ...(status ? inputStatusColorMap[status] : undefined),
                }}
            />
        </Box>
    );
};

export default ApplicationStatus;